import { z } from "zod";

export const AppInfoSchema = z.object({
  latestVersion: z.string(),
  minimumVersion: z.string(),
});

export type AppInfo = z.infer<typeof AppInfoSchema>;
